/**
 * Page visibility config.
 * Set any page to `false` to hide it from navigation and return a 404.
 * Works like WordPress draft mode: flip the boolean and redeploy.
 */
export const pageVisibility: Record<string, boolean> = {
  // Main pages
  "/": true,
  "/news": true,
  "/learn": false,
  "/markets": true,
  "/scorecard": false,
  "/search": true,
  "/contact": true,
  "/summit": true,

  // About
  "/about": true,
  "/about/editorial-team": true,
  "/about/editorial-guidelines": true,
  "/about/privacy-policy": true,
  "/about/terms-and-conditions": true,
  "/about/press": true,
  "/about/announcements": true,

  // Explore
  "/prediction-markets": false,
  "/prediction-market-apps": false,
  "/legal": false,

  // Category pages
  "/sports": true,
  "/politics": false,
  "/crypto": false,
  "/economics": false,
  "/finance": false,
  "/tech": false,
  "/culture": false,
  "/companies": false,
  "/weather": false,
  "/mentions": false,

  // Platform pages
  "/polymarket-review": false,
  "/kalshi": false,
  "/predictit": false,
  "/fanduel-predicts": false,
  "/draftkings-predictions": false,
  "/robinhood": false,
  "/coinbase": false,
  "/forecastex": false,
  "/og-predictions": false,

  // Comparison pages
  "/kalshi-vs-polymarket": false,
  "/polymarket-vs-predictit": false,
  "/best-prediction-markets": false,
  "/best-prediction-markets-for-sports": false,

  // Legal pages
  "/are-prediction-markets-legal": false,
  "/cftc-prediction-market-rules": false,
  "/prediction-market-taxes": false,
};

/**
 * Homepage section visibility.
 * Set any section to `false` to hide it from the homepage.
 */
export const sectionVisibility: Record<string, boolean> = {
  podcast: false,
  featured: false,
  categoryColumns: true,
  trendingMarkets: true,
  quickPredictions: true,
  marketSidebar: true,
  newsletterBanner: true,
  newsletterPopup: true,
  inlineCTA: true,
  marketPulse: true,
};

/** Check if a page path is enabled */
export function isPageVisible(path: string): boolean {
  return pageVisibility[path] !== false;
}

/** Check if a homepage section is enabled */
export function isSectionVisible(section: string): boolean {
  return sectionVisibility[section] !== false;
}
